import { useEffect, useRef, useState } from "react";

// True after `timeout` ms without any user activity; false again on the
// next pointer/key/touch. Used to let controls sink into the background.
// by David Hunt
export const useIdle = (timeout = 7000) => {
  const [idle, setIdle] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    const reset = () => {
      setIdle(false);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setIdle(true), timeout);
    };
    const events = ["pointermove", "pointerdown", "keydown", "touchstart", "wheel"];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      events.forEach((e) => window.removeEventListener(e, reset));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [timeout]);

  return idle;
};
